import { useState } from "react";
import Icon from "../../../../../Assets/Icons/Admin panel/filter.svg";
import {
  TextField,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
} from "@mui/material";
import InputAdornment from "@mui/material/InputAdornment";
import IconButton from "@mui/material/IconButton";
import SearchIcon from "@mui/icons-material/Search";

const Filters = (props) => {
  const [selectedProfiles, setSelectedProfiles] = useState([]);
  const [selectedStatus, setSelectedStatus] = useState([]);

  const handleProfileChange = (event) => {
    setSelectedProfiles(event.target.value);
    props.ToggleSearch(event.target.value, selectedStatus);
  };
  const handleStatusChange = (event) => {
    setSelectedStatus(event.target.value);
    props.ToggleSearch(selectedProfiles, event.target.value);
  };

  return (
    <div
      className="filters-wrapper"
      style={
        props.SelectedNavTab !== "FIRST" || props.EditUserIsActive
          ? { pointerEvents: "none", zIndex: "0" }
          : {}
      }
    >
      {props.SelectedNavTab !== "FIRST" || props.EditUserIsActive ? (
        <div className="disabled-overlay"></div>
      ) : null}
      <section className="section-name">
        <img src={Icon} alt="" />
        <p>Filters</p>
      </section>
      <div className="filters">
        <TextField
          placeholder="Username or name..."
          variant="outlined"
          label="Search"
          id="search-input"
          onChange={() => props.ToggleSearch()}
          fullWidth
          sx={{
            "& .MuiOutlinedInput-root": {
              borderColor: "#171717", // Change border color
            },
          }}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <IconButton>
                  <SearchIcon />
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
        <FormControl variant="outlined" fullWidth sx={{ marginTop: "16px" }}>
          <InputLabel id="assigned-profile-label">Assigned Profile</InputLabel>
          <Select
            labelId="assigned-profile-label"
            id="assigned-profile"
            multiple
            value={selectedProfiles}
            onChange={handleProfileChange}
            label="Assigned Profile"
            inputProps={{ MenuProps: { disableScrollLock: true } }}
            sx={{
              "& .MuiOutlinedInput-root": {
                borderColor: "#171717", // Change border color
              },
            }}
          >
            <MenuItem value="ROLE_ADMIN">Admin</MenuItem>
            <MenuItem value="ROLE_USER">User</MenuItem>
          </Select>
        </FormControl>
        <FormControl variant="outlined" fullWidth sx={{ marginTop: "16px" }}>
          <InputLabel id="status-label">Status</InputLabel>
          <Select
            labelId="status-label"
            id="status"
            multiple
            value={selectedStatus}
            onChange={handleStatusChange}
            inputProps={{ MenuProps: { disableScrollLock: true } }}
            label="Status"
            sx={{
              "& .MuiOutlinedInput-root": {
                borderColor: "#171717", // Change border color
              },
            }}
          >
            <MenuItem value="ACTIVE">Active</MenuItem>
            <MenuItem value="INACTIVE">Inactive</MenuItem>
          </Select>
        </FormControl>
      </div>
    </div>
  );
};

export default Filters;
